<template>
  <div class="fixed bottom-6 right-6 z-50">
    <!-- Main WhatsApp Button -->
    <button 
      @click="toggleForm"
      class="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 group relative"
    >
      <div class="absolute inset-0 rounded-full border-2 border-white/20 animate-ping"></div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-7 h-7" fill="currentColor">
        <path d="M12.031 0C5.385 0 0 5.386 0 12.032c0 2.128.555 4.195 1.611 6.01L.062 24l6.115-1.605A11.968 11.968 0 0 0 12.031 24c6.645 0 12.03-5.386 12.03-12.032S18.676 0 12.031 0zm0 22.016c-1.802 0-3.565-.483-5.111-1.401l-.367-.217-3.793.996.994-3.79-.239-.379A9.972 9.972 0 0 1 2.015 12.03c0-5.529 4.498-10.027 10.027-10.027 5.53 0 10.027 4.498 10.027 10.027s-4.497 10.027-10.027 10.027z" />
        <path d="M17.511 14.186c-.302-.152-1.782-.879-2.058-.98-.276-.101-.478-.152-.679.152-.201.303-.778.98-.954 1.18-.176.202-.352.227-.654.076-.302-.152-1.274-.47-2.427-1.496-.897-.798-1.503-1.785-1.68-2.088-.176-.303-.019-.467.132-.618.136-.137.303-.353.454-.53.151-.176.201-.302.302-.504.1-.201.05-.378-.025-.53-.076-.151-.68-1.64-.931-2.245-.245-.59-.494-.509-.679-.518-.176-.008-.378-.01-.579-.01-.202 0-.528.075-.805.378-.277.302-1.057 1.033-1.057 2.518 0 1.485 1.082 2.918 1.233 3.12.151.202 2.128 3.251 5.155 4.557.721.31 1.282.496 1.722.635.723.23 1.381.197 1.897.12.576-.086 1.782-.728 2.034-1.432.251-.703.251-1.306.176-1.432-.076-.126-.277-.201-.579-.352z" />
      </svg>
    </button>

    <!-- Lead Capture Form Popup -->
    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="translate-y-4 opacity-0 scale-95"
      enter-to-class="translate-y-0 opacity-100 scale-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="translate-y-0 opacity-100 scale-100"
      leave-to-class="translate-y-4 opacity-0 scale-95"
    >
      <div v-if="showForm" class="absolute bottom-20 right-0 w-80 bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden origin-bottom-right">
        <div class="bg-[#25D366] p-4 text-white flex justify-between items-center">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 h-4" fill="currentColor">
                <path d="M12.031 0C5.385 0 0 5.386 0 12.032c0 2.128.555 4.195 1.611 6.01L.062 24l6.115-1.605A11.968 11.968 0 0 0 12.031 24c6.645 0 12.03-5.386 12.03-12.032S18.676 0 12.031 0zm0 22.016c-1.802 0-3.565-.483-5.111-1.401l-.367-.217-3.793.996.994-3.79-.239-.379A9.972 9.972 0 0 1 2.015 12.03c0-5.529 4.498-10.027 10.027-10.027 5.53 0 10.027 4.498 10.027 10.027s-4.497 10.027-10.027 10.027z" />
                <path d="M17.511 14.186c-.302-.152-1.782-.879-2.058-.98-.276-.101-.478-.152-.679.152-.201.303-.778.98-.954 1.18-.176.202-.352.227-.654.076-.302-.152-1.274-.47-2.427-1.496-.897-.798-1.503-1.785-1.68-2.088-.176-.303-.019-.467.132-.618.136-.137.303-.353.454-.53.151-.176.201-.302.302-.504.1-.201.05-.378-.025-.53-.076-.151-.68-1.64-.931-2.245-.245-.59-.494-.509-.679-.518-.176-.008-.378-.01-.579-.01-.202 0-.528.075-.805.378-.277.302-1.057 1.033-1.057 2.518 0 1.485 1.082 2.918 1.233 3.12.151.202 2.128 3.251 5.155 4.557.721.31 1.282.496 1.722.635.723.23 1.381.197 1.897.12.576-.086 1.782-.728 2.034-1.432.251-.703.251-1.306.176-1.432-.076-.126-.277-.201-.579-.352z" />
              </svg>
            </div>
            <div>
              <h3 class="text-sm font-bold leading-none">Chat with ALARM</h3>
              <p class="text-[10px] text-white/80 mt-1">Usually replies in 5 minutes</p>
            </div>
          </div>
          <button @click="showForm = false" class="text-white/60 hover:text-white transition-colors">
            <component :is="XIcon" class="w-4 h-4" />
          </button>
        </div>

        <div class="p-5 space-y-4">
          <p class="text-xs text-slate-500 mb-2">Please introduce yourself before starting the chat.</p>
          
          <div class="space-y-3">
            <div>
              <label class="block text-[9px] font-bold uppercase tracking-widest text-slate-400 mb-1 ml-1">Your Name</label>
              <input v-model="form.name" type="text" class="w-full h-10 px-3 rounded-lg bg-slate-50 border border-slate-100 text-xs font-bold text-slate-900 focus:bg-white focus:border-[#25D366] focus:outline-none focus:ring-4 focus:ring-[#25D366]/10 transition-all" />
            </div>
            <div>
              <label class="block text-[9px] font-bold uppercase tracking-widest text-slate-400 mb-1 ml-1">WhatsApp Number</label>
              <input v-model="form.phone" type="tel" placeholder="+974 " class="w-full h-10 px-3 rounded-lg bg-slate-50 border border-slate-100 text-xs font-bold text-slate-900 focus:bg-white focus:border-[#25D366] focus:outline-none focus:ring-4 focus:ring-[#25D366]/10 transition-all" />
            </div>
          </div>

          <button 
            @click="submitLead" 
            :disabled="loading || !form.name || !form.phone"
            class="w-full h-10 mt-2 bg-[#25D366] hover:bg-[#128C7E] text-white font-bold rounded-lg uppercase tracking-widest text-[10px] transition-all flex items-center justify-center gap-2 shadow-lg shadow-[#25D366]/20 disabled:opacity-50"
          >
            <span v-if="!loading">Start Chat</span>
            <div v-else class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'
import { X as XIcon } from 'lucide-vue-next'
import { useTrackingStore } from '~/stores/tracking'

const WHATSAPP_NUMBER = '97430812223' // Replace with actual number
const trackingStore = useTrackingStore()
const showForm = ref(false)
const loading = ref(false)
const hasSubmitted = ref(false)

const form = reactive({
  name: '',
  phone: ''
})

onMounted(() => {
  if (process.client) {
    hasSubmitted.value = localStorage.getItem('lead_submitted') === 'true'
  }
})

const toggleForm = () => {
  if (hasSubmitted.value) {
    // If they already submitted info in the past, just log intent and open WA
    trackingStore.logAction('WhatsApp Chat Started')
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=Hi, I would like more information from your website.`, '_blank')
  } else {
    showForm.value = !showForm.value
  }
}

const submitLead = async () => {
  if (!form.name || !form.phone) return
  loading.value = true
  
  try {
    await trackingStore.captureLead({
      name: form.name,
      phone: form.phone,
      source: 'WhatsApp'
    })
    
    trackingStore.addScore(20, 'WhatsApp Click')

    if (process.client) {
      localStorage.setItem('lead_submitted', 'true')
    }
    hasSubmitted.value = true
    showForm.value = false
    
    // Redirect to WhatsApp
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=Hi, I am ${form.name}. I would like more information.`, '_blank')
  } catch (error) {
    console.error('Lead capture error', error)
  } finally {
    loading.value = false
  }
}
</script>
